import { render } from "./TrainingConfirmation.vue?vue&type=template&id=88438f88&scoped=true&lang=pug"
import script from "./TrainingConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainingConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./TrainingConfirmation.vue?vue&type=style&index=0&id=88438f88&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88438f88"]])

export default __exports__